<script lang="ts" setup>
import type { Ref } from 'vue'
import { ref } from 'vue'

interface MenuItem {
  title: string
  value: string
  prependIcon?: string | (() => string)
  onClick?: () => void
  type?: string
  model?: Ref<boolean> | boolean
}

interface Props {
  menuList?: MenuItem[]
  itemProps?: boolean
  iconSize?: string
}

const props = defineProps<Props>()
const isMenuOpen = ref(false)
</script>

<template>
  <IconBtn>
    <VIcon icon="ri-more-2-line" :size="iconSize" />

    <VMenu
      v-if="props.menuList"
      v-model="isMenuOpen"
      activator="parent"
      :close-on-content-click="false"
    >
      <VList>
        <template v-for="item in props.menuList" :key="item.value">
          <!-- Обычный пункт меню -->
          <VListItem
            v-if="item.type !== 'switcher'"
            :value="item.value"
            @click="() => {
              item.onClick?.()
              isMenuOpen = false
            }"
          >
            <template v-if="item.prependIcon" #prepend>
              <VIcon :icon="item.prependIcon" />
            </template>

            <VListItemTitle>{{ item.title }}</VListItemTitle>
          </VListItem>

          <!-- Пункт меню со свитчером -->
          <VListItem
            v-else
            class="px-4 py-1"
            @click.stop="() => {
              if (item.model) {
                const currentValue = typeof item.model === 'object' && 'value' in item.model
                  ? item.model.value
                  : item.model
                if (typeof item.model === 'object' && 'value' in item.model) {
                  (item.model as Ref<boolean>).value = !currentValue
                }
              }
            }"
          >
            <div class="d-flex align-center w-100">
              <!-- Иконка -->
              <VIcon
                v-if="item.prependIcon"
                :icon="typeof item.prependIcon === 'function' ? item.prependIcon() : item.prependIcon"
                size="22"
                class="me-2"
              />

              <!-- Заголовок -->
              <span class="flex-grow-1">{{ item.title }}</span>

              <!-- Свитчер -->
              <VSwitch
                v-if="item.model"
                :model-value="typeof item.model === 'object' && 'value' in item.model ? item.model.value : item.model"
                inset
                hide-details
                @update:model-value="(value: boolean) => {
                  if (typeof item.model === 'object' && 'value' in item.model) {
                    (item.model as Ref<boolean>).value = value
                  }
                }"
                @click.stop
              />
            </div>
          </VListItem>
        </template>
      </VList>
    </VMenu>
  </IconBtn>
</template>
